export const GENERAL_SERVER_ERROR = 'Error Processing Request'; // TODO confirm with product what this should be
